import { useMemo, useCallback } from 'react';
import orderBy from 'lodash/orderBy';
import useArrayFilters from 'hooks/useArrayFilters';
import DropdownSelect from 'components/DropdownSelect';
import useLocalDispatch from '../../../hooks/useLocalDispatch';
import { fetchSandboxCreators as _fetchSandboxCreators } from 'thunk';

const stateId = 'fetch-sandbox-creators';

const useSandboxCreatorSelector = ({
  variant = 'standard',
}: { variant?: 'standard' | 'outlined' } = {}) => {
  const { dispatchLocal, selectLocalData } = useLocalDispatch();
  const { data: sandboxCreatorsArray, error } = selectLocalData<string[]>({
    stateId,
  });

  const sortedCreatorList = useMemo(() => orderBy(sandboxCreatorsArray), [sandboxCreatorsArray]);

  const { items, selectedItems, onSelect, clearSelection, isMultiSelect } = useArrayFilters({
    items: sortedCreatorList,
  });

  const handleClearSelectedCreators = useCallback(() => {
    clearSelection();
  }, [clearSelection]);

  const fetchSandboxCreators = useCallback(() => {
    dispatchLocal(_fetchSandboxCreators, {
      params: {},
      stateId,
      formatSuccessResponse: ({ response }) => {
        return response.data?.creators || [];
      },
    });
  }, [dispatchLocal]);

  const SandboxCreatorSelector = (
    <DropdownSelect
      inputLabel={'Created by'}
      items={items}
      itemHash={null}
      selectedItems={selectedItems}
      onSelect={onSelect}
      isMultiSelect={isMultiSelect}
      variant={variant}
    />
  );

  return {
    selectedCreators: selectedItems,
    handleClearSelectedCreators,
    SandboxCreatorSelector,
    fetchSandboxCreators,
  };
};

export default useSandboxCreatorSelector;
